"use strict";
exports.__esModule = true;
exports.SvgVersionCurrent = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgVersionCurrent = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M21.903 13.886a.736.736 0 01-.211.964l-.088.056-9.23 5a.787.787 0 01-.645.046l-.103-.046-9.23-5a.741.741 0 01-.3-1.02.78.78 0 01.952-.335l.095.044L12 18.392l8.857-4.797a.78.78 0 011.046.29zm-9.417-9.76l8.98 4.958a1.051 1.051 0 010 1.832l-8.98 4.958a1 1 0 01-.972 0l-8.98-4.958a1.051 1.051 0 010-1.832l8.98-4.958a1 1 0 01.972 0zM12 5.633L4.092 10 12 14.366 19.907 10 12 5.633z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=VersionCurrent.js.map